var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-wrappper" },
    [
      _c("div", { staticClass: "row submission-container" }, [
        _vm.permissions.includes("LAUNCHPAD_ACTIVITY_TRACKER")
          ? _c("div", { staticClass: "col-xs-12 pb-15" }, [
              _c("span", { staticClass: "content-header" }, [
                _vm._v("Activity Tracker"),
              ]),
            ])
          : _vm._e(),
        _vm.permissions.includes("LAUNCHPAD_ACTIVITY_TRACKER")
          ? _c("div", { staticClass: "col-md-12 tabs_pl pb-15" }, [
              _c("div", { staticClass: "border_bt" }, [
                _c("div", { staticClass: "row flex-widgets" }, [
                  _vm.permissions.includes(
                    "LAUNCHPAD_ACTIVITY_TRACKER_ACCOUNTS_COUNTER_WIDGET"
                  )
                    ? _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-4 col-md-4 tab_widget",
                        },
                        [
                          _c("div", { staticClass: "border-tabs" }, [
                            _c("div", { staticClass: "account_header" }, [
                              _vm._m(0),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "account_header_content cursor-pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.routeURL(
                                        "/layout/activitytracker",
                                        "accounts"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("capitalize")(
                                          _vm.accountsInfo.name
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "account_count" }, [
                                _vm._v(_vm._s(_vm.accountsInfo.count)),
                              ]),
                            ]),
                            _c("div", { staticClass: "account_body_content" }, [
                              _c("div", { staticClass: "content_pb" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "account_rep cursor-pointer",
                                    on: {
                                      click: function ($event) {
                                        return _vm.routeFilter(
                                          { account_type: "rep" },
                                          "accounts"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" Rep accounts ")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "account_rep_count" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getData(
                                            _vm.accountsInfo.summary_info,
                                            "rep",
                                            "count"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "account_rep cursor-pointer activity-height",
                                    on: {
                                      click: function ($event) {
                                        return _vm.routeFilter(
                                          { account_type: "commercial" },
                                          "accounts"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" Commercial accounts ")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "account_rep_count" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getData(
                                            _vm.accountsInfo.summary_info,
                                            "commercial",
                                            "count"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.permissions.includes(
                    "LAUNCHPAD_ACTIVITY_TRACKER_USERS_COUNTER_WIDGET"
                  )
                    ? _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-4 col-md-4 tab_widget",
                        },
                        [
                          _c("div", { staticClass: "border-tabs" }, [
                            _c("div", { staticClass: "user_header" }, [
                              _vm._m(1),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "account_header_content cursor-pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.routeURL(
                                        "/layout/activitytracker/",
                                        "users"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("capitalize")(_vm.usersInfo.name)
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "el-popover",
                                    {
                                      staticClass: "main_popover",
                                      attrs: {
                                        placement: "right-end",
                                        trigger: "hover",
                                        width: "550",
                                      },
                                      on: {
                                        show: function ($event) {
                                          _vm.infoActive = true
                                        },
                                        hide: function ($event) {
                                          _vm.infoActive = false
                                        },
                                      },
                                    },
                                    [
                                      !_vm.infoActive
                                        ? _c("img", {
                                            staticClass: "info-img",
                                            attrs: {
                                              slot: "reference",
                                              src: "/static/images/icons/info_white_icon.svg",
                                              alt: "info-icon",
                                            },
                                            slot: "reference",
                                          })
                                        : _vm._e(),
                                      _vm.infoActive
                                        ? _c("img", {
                                            staticClass: "info-img",
                                            attrs: {
                                              slot: "reference",
                                              src: "/static/images/icons/info_white_icon_active.svg",
                                              alt: "infoactive-icon",
                                            },
                                            slot: "reference",
                                          })
                                        : _vm._e(),
                                      _c("div", { staticClass: "info-tabs" }, [
                                        _c(
                                          "ul",
                                          {
                                            staticClass: "nav nav-tabs",
                                            attrs: { role: "tablist" },
                                          },
                                          [
                                            _c(
                                              "li",
                                              {
                                                staticClass: "nav-item",
                                                class: {
                                                  active:
                                                    _vm.activeTab == "UserList",
                                                },
                                                attrs: { role: "presentation" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "nav-link",
                                                    attrs: {
                                                      role: "tab",
                                                      "data-toggle": "tab",
                                                    },
                                                  },
                                                  [_vm._v("User List")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "info-text" },
                                          [
                                            _vm._v(
                                              " Some user roles can be associated with multiple accounts, such as Consultant, PM, Support Admins. Each association is counted as a unique user. This count differs from the Launchpad as no filters are applied so that all user associations can be accessed. "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "account_count" }, [
                                _vm._v(_vm._s(_vm.usersInfo.count)),
                              ]),
                            ]),
                            _c("div", { staticClass: "account_body_content" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "content_pb cursor-pointer activity-height",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "account_rep",
                                      on: {
                                        click: function ($event) {
                                          return _vm.routeFilter(
                                            { account_type: "rep" },
                                            "users"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" Rep users ")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "account_rep_count" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getData(
                                              _vm.usersInfo.summary_info,
                                              "rep",
                                              "count"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "content_pb cursor-pointer activity-height",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "account_rep",
                                      on: {
                                        click: function ($event) {
                                          return _vm.routeFilter(
                                            { account_type: "commercial" },
                                            "users"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" Commercial users ")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "account_rep_count" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getData(
                                              _vm.usersInfo.summary_info,
                                              "commercial",
                                              "count"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "content_pb cursor-pointer activity-height",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "account_rep",
                                      on: {
                                        click: function ($event) {
                                          return _vm.routeFilter(
                                            { account_type: "repcommercial" },
                                            "users"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" Rep/Commercial users ")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "account_rep_count" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getData(
                                              _vm.usersInfo.summary_info,
                                              "both",
                                              "count"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.permissions.includes(
                    "LAUNCHPAD_ACTIVITY_TRACKER_USERS_COUNTER_WIDGET"
                  )
                    ? _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-4 col-md-4 tab_widget",
                        },
                        [
                          _c("div", { staticClass: "border-tabs" }, [
                            _c(
                              "table",
                              {
                                staticClass:
                                  "table m-0 text-center service-table custom-border",
                              },
                              [
                                _vm._m(2),
                                _c("tbody", [
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass:
                                          "premium-services summary_title",
                                      },
                                      [_vm._v("Total Accounts")]
                                    ),
                                    _c("td", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getData(
                                              _vm.summaryInfo.summary_info,
                                              "totalAccounts",
                                              "count"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("td", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getData(
                                              _vm.summaryInfoLastWeek
                                                .summary_info,
                                              "totalAccounts",
                                              "count"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass:
                                          "premium-services summary_title",
                                      },
                                      [_vm._v("Rep Accounts")]
                                    ),
                                    _c("td", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getData(
                                              _vm.summaryInfo.summary_info,
                                              "repAccounts",
                                              "count"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("td", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getData(
                                              _vm.summaryInfoLastWeek
                                                .summary_info,
                                              "repAccounts",
                                              "count"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass:
                                          "premium-services summary_title",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "account_rep" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "pr-5" },
                                              [_vm._v("Commercial accounts")]
                                            ),
                                            _c(
                                              "router-link",
                                              { attrs: { to: "" } },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-plus pr-5",
                                                  class: {
                                                    "fa fa-plus pr-5":
                                                      _vm.visible === false,
                                                    "fa fa-minus pr-5":
                                                      _vm.visible === true,
                                                  },
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                  on: {
                                                    click: _vm.toggleDisplay,
                                                  },
                                                }),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _c("td", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getData(
                                              _vm.summaryInfo.summary_info,
                                              "commercialAccounts",
                                              "count"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("td", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getData(
                                              _vm.summaryInfoLastWeek
                                                .summary_info,
                                              "commercialAccounts",
                                              "count"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _vm.visible
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "premium-services drill-down-title",
                                          },
                                          [_vm._v("Free accounts")]
                                        ),
                                        _c(
                                          "td",
                                          { staticClass: "drill-down-value" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getData(
                                                    _vm.summaryInfo
                                                      .summary_info,
                                                    "freeAccounts",
                                                    "count"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { staticClass: "drill-down-value" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getData(
                                                    _vm.summaryInfoLastWeek
                                                      .summary_info,
                                                    "freeAccounts",
                                                    "count"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.visible
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "premium-services drill-down-title",
                                          },
                                          [_vm._v("Trial accounts")]
                                        ),
                                        _c(
                                          "td",
                                          { staticClass: "drill-down-value" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getData(
                                                    _vm.summaryInfo
                                                      .summary_info,
                                                    "trialAccountsCount",
                                                    "count"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { staticClass: "drill-down-value" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getData(
                                                    _vm.summaryInfoLastWeek
                                                      .summary_info,
                                                    "trialAccountsCount",
                                                    "count"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.visible
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "premium-services drill-down-title",
                                          },
                                          [_vm._v("Trial expired accounts")]
                                        ),
                                        _c(
                                          "td",
                                          { staticClass: "drill-down-value" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getData(
                                                    _vm.summaryInfo
                                                      .summary_info,
                                                    "trialExpiredAccounts",
                                                    "count"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { staticClass: "drill-down-value" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getData(
                                                    _vm.summaryInfoLastWeek
                                                      .summary_info,
                                                    "trialExpiredAccounts",
                                                    "count"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.visible
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "premium-services drill-down-title",
                                          },
                                          [_vm._v("Premium fully paid")]
                                        ),
                                        _c(
                                          "td",
                                          { staticClass: "drill-down-value" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getData(
                                                    _vm.summaryInfo
                                                      .summary_info,
                                                    "premiumFullyPaidAccounts",
                                                    "count"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { staticClass: "drill-down-value" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getData(
                                                    _vm.summaryInfoLastWeek
                                                      .summary_info,
                                                    "premiumFullyPaidAccounts",
                                                    "count"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass:
                                          "premium-services summary_title",
                                      },
                                      [_vm._v("Total users added")]
                                    ),
                                    _c("td", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getData(
                                              _vm.summaryInfo.summary_info,
                                              "totalUsers",
                                              "count"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("td", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getData(
                                              _vm.summaryInfoLastWeek
                                                .summary_info,
                                              "totalUsers",
                                              "count"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm.permissions.includes(
          "LAUNCHPAD_ACTIVITY_TRACKER_PREMIUM_SERVICE_TABLE"
        )
          ? _c("div", { staticClass: "col-md-12 tabs_pl pb-15" }, [
              _c("div", { staticClass: "border_bt" }, [
                _c("div", { staticClass: "row widget_row" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12 col-md-12 tab_widget" },
                    [
                      _c("div", { staticClass: "border-tabs" }, [
                        _vm._m(3),
                        _c(
                          "div",
                          {
                            staticClass: "account_body_content overflow_scroll",
                          },
                          [
                            _c(
                              "table",
                              {
                                staticClass:
                                  "table table-striped table-bordered text-center service-table",
                              },
                              [
                                _vm._m(4),
                                _c(
                                  "tbody",
                                  [
                                    _vm._l(_vm.services, function (service) {
                                      return _c("tr", { key: service.id }, [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "premium-services cursor-pointer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.routeFilter(
                                                  {
                                                    services_registered:
                                                      service.name,
                                                  },
                                                  "accounts"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(service.name) + " "
                                            ),
                                            service.name ===
                                            "Product Classification"
                                              ? _c(
                                                  "span",
                                                  { staticClass: "sub-text" },
                                                  [
                                                    _c("br"),
                                                    _vm._v(
                                                      "Accounts w/multi-plans are counted once"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c("td", [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "premium-services cursor-pointer",
                                              attrs: {
                                                href: "javascript:void(0);",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.routeFilter(
                                                    {
                                                      services_registered:
                                                        service.name,
                                                      account_type: "rep",
                                                    },
                                                    "accounts"
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(service.rep || 0))]
                                          ),
                                        ]),
                                        _c("td", [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "premium-services cursor-pointer",
                                              attrs: {
                                                href: "javascript:void(0);",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.routeFilter(
                                                    {
                                                      services_registered:
                                                        service.name,
                                                      account_type:
                                                        "commercial",
                                                    },
                                                    "accounts"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(service.nonRep || 0)
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _c("td", [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "premium-services cursor-pointer",
                                              attrs: {
                                                href: "javascript:void(0);",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.routeFilter(
                                                    {
                                                      services_registered:
                                                        service.name,
                                                      service_expiry:
                                                        "expiring30Days",
                                                    },
                                                    "accounts"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  service.expiring_in30_days ||
                                                    0
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _c("td", [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "premium-services cursor-pointer",
                                              attrs: {
                                                href: "javascript:void(0);",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.routeFilter(
                                                    {
                                                      services_registered:
                                                        service.name,
                                                      service_expiry:
                                                        "expiring30To45Days",
                                                    },
                                                    "accounts"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  service.expiring_in45_days ||
                                                    0
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ])
                                    }),
                                    _vm.areTeamMembersAvailable
                                      ? _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "premium-services cursor-pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.routeFilter(
                                                    {
                                                      services_registered:
                                                        "Team Members",
                                                    },
                                                    "accounts"
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" Team Members ")]
                                          ),
                                          _c("td", [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "premium-services cursor-pointer",
                                                attrs: {
                                                  href: "javascript:void(0);",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.routeFilter(
                                                      {
                                                        services_registered:
                                                          "Team Members",
                                                        account_type: "rep",
                                                      },
                                                      "accounts"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.teamMembersDetails
                                                      .rep || 0
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("td", [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "premium-services cursor-pointer",
                                                attrs: {
                                                  href: "javascript:void(0);",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.routeFilter(
                                                      {
                                                        services_registered:
                                                          "Team Members",
                                                        account_type:
                                                          "commercial",
                                                      },
                                                      "accounts"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.teamMembersDetails
                                                      .nonRep || 0
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("td", [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "premium-services cursor-pointer",
                                                attrs: {
                                                  href: "javascript:void(0);",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.routeFilter(
                                                      {
                                                        services_registered:
                                                          "Team Members",
                                                        service_expiry:
                                                          "expiring30Days",
                                                      },
                                                      "accounts"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.teamMembersDetails
                                                      .expiring_in30_days || 0
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("td", [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "premium-services cursor-pointer",
                                                attrs: {
                                                  href: "javascript:void(0);",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.routeFilter(
                                                      {
                                                        services_registered:
                                                          "Team Members",
                                                        service_expiry:
                                                          "expiring30To45Days",
                                                      },
                                                      "accounts"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.teamMembersDetails
                                                      .expiring_in45_days || 0
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm.permissions.includes("LAUNCHPAD_ADMIN_TOOLS")
          ? _c("div", { staticClass: "col-xs-12 pb-15" }, [
              _c("span", { staticClass: "content-header" }, [
                _vm._v("Admin Tools"),
              ]),
            ])
          : _vm._e(),
        _vm.permissions.includes("LAUNCHPAD_ADMIN_TOOLS_SERVICE_MANAGER")
          ? _c("div", { staticClass: "col-xs-12 pb-15" }, [
              _c("div", { staticClass: "row border-1" }, [
                _vm._m(5),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4" },
                    [
                      _c("div", { staticClass: "row border-2" }, [
                        _vm._m(6),
                        _c("div", { staticClass: "col-md-9 col-xs-9 pr-0" }, [
                          _c("div", { staticClass: "mt-5 desc-box" }, [
                            _c(
                              "span",
                              {
                                staticClass: "product-service cursor-pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.routeURL(
                                      "/layout/launchpad/submissionbuilderadmin"
                                    )
                                  },
                                },
                              },
                              [_c("span", [_vm._v("Smart Builder")])]
                            ),
                            _c("p", { staticClass: "product-content" }, [
                              _vm._v(
                                " Service administrator access. Template management and service configurations. "
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm.permissions.includes("LAUNCHPAD_ADMIN_TOOLS_OPERATIONS")
          ? _c("div", { staticClass: "col-xs-12 pb-15" }, [
              _c("div", { staticClass: "row border-1" }, [
                _vm._m(7),
                _c("div", { staticClass: "row" }, [
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4" },
                      [
                        _c("div", { staticClass: "row border-2" }, [
                          _vm._m(8),
                          _c("div", { staticClass: "col-md-9 col-xs-9 pr-0" }, [
                            _c("div", { staticClass: "mt-5" }, [
                              _vm._m(9),
                              _c(
                                "div",
                                { staticClass: "product-list-content row" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-8 pr-0" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/layout/launchpad/addcompany",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-plus pr-5",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _vm._v("Add Company "),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-4 br-list" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/layout/launchpad/companylist",
                                          },
                                        },
                                        [_vm._v("List")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "product-list-content row" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-8 pr-0" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/layout/launchpad/addproduct",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-plus pr-5",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _vm._v("Add Product "),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-4 br-list" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/layout/launchpad/productlist",
                                          },
                                        },
                                        [_vm._v("List")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "product-list-content row" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-8 pr-0" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/layout/launchpad/addproject",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-plus pr-5",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _vm._v("Add Project "),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-4 br-list" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/layout/launchpad/projectlist",
                                          },
                                        },
                                        [_vm._v("List")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "product-list-content row" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-8 pr-0" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/layout/launchpad/addconsultant",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-plus pr-5",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _vm._v("Add Consultant "),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-4 br-list" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/layout/launchpad/consultantslist",
                                          },
                                        },
                                        [_vm._v("List")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "product-list-content row" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-8 pr-0" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/layout/launchpad/addprojectmanager",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-plus pr-5",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _vm._v("Add Project Manager "),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-4 br-list" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/layout/launchpad/projectmanagerslist",
                                          },
                                        },
                                        [_vm._v("List")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "product-list-content row" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-8 pr-0 pr-5" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/layout/launchpad/activateservice",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-plus pr-5",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _vm._v("Activate Service in RAMS "),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-4 br-list" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/layout/launchpad/activeaccountslist",
                                          },
                                        },
                                        [_vm._v("List")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              false
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "product-list-content row",
                                      attrs: { "data-v-481e9ed3": "" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-xs-8 pr-0 pr-5" },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: "/layout/launchpad/activaterationale",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-plus pr-5",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              }),
                                              _vm._v(
                                                "Activate Rationale Requets in RAMS "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "col-xs-4 br-list" },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: "/layout/launchpad/activeaccountslist",
                                              },
                                            },
                                            [_vm._v("List")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "product-list-content row" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/layout/launchpad/exportaudit",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "View Smart Builder Audit Trail"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4" },
                      [
                        _c("div", { staticClass: "row border-2" }, [
                          _vm._m(10),
                          _c("div", { staticClass: "col-md-9 col-xs-9 pr-0" }, [
                            _c("div", { staticClass: "mt-5" }, [
                              _vm._m(11),
                              _c(
                                "div",
                                { staticClass: "product-list-content row" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-8 pr-0" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/layout/launchpad/addsalesteam",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-plus pr-5",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _vm._v("Add Sales Team "),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-4 br-list" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/layout/launchpad/salesteamlist",
                                          },
                                        },
                                        [_vm._v("List")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "product-list-content row" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-8 pr-0" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/layout/launchpad/addrepprojectmanager",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-plus pr-5",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _vm._v("Add REP Project Manager "),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-4 br-list" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/layout/launchpad/repprojectmanagerlist",
                                          },
                                        },
                                        [_vm._v("List")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "product-list-content row" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-8 pr-0" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/layout/launchpad/addrepconsultant",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-plus pr-5",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _vm._v("Add REP Consultant "),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-4 br-list" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/layout/launchpad/repconsultantlist",
                                          },
                                        },
                                        [_vm._v("List")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm.permissions.includes("LAUNCHPAD_ADMIN_TOOLS_SYSTEM")
          ? _c("div", { staticClass: "col-xs-12 pb-15" }, [
              _c("div", { staticClass: "row border-1" }, [
                _vm._m(12),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-6 col-md-6 col-lg-4 tab_widget",
                    },
                    [
                      _c("div", { staticClass: "row border-2" }, [
                        _vm._m(13),
                        _c("div", { staticClass: "col-md-9 col-xs-9 pr-0" }, [
                          _c("div", { staticClass: "mt-5 desc-box" }, [
                            _c(
                              "span",
                              {
                                staticClass: "product-service cursor-pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.routeURL(
                                      "/layout/launchpad/systemnotificationslist"
                                    )
                                  },
                                },
                              },
                              [_c("span", [_vm._v("System Notifications")])]
                            ),
                            _c("p", { staticClass: "product-content" }, [
                              _vm._v(
                                " System-wide User notification management. Display advance warning messages and system critical updates. "
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4" },
                    [
                      _c("div", { staticClass: "row border-2" }, [
                        _vm._m(14),
                        _c("div", { staticClass: "col-md-9 col-xs-9 pr-0" }, [
                          _c("div", { staticClass: "mt-5 desc-box" }, [
                            _c(
                              "span",
                              {
                                staticClass: "product-service cursor-pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.routeURL(
                                      "/layout/launchpad/rbac/RBACManagement"
                                    )
                                  },
                                },
                              },
                              [_c("span", [_vm._v("RBAC")])]
                            ),
                            _c("p", { staticClass: "product-content" }, [
                              _vm._v(
                                " System-wide user management. Providing user access for various services, modules and sub modules "
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "account_img_icon" }, [
      _c("img", {
        attrs: {
          src: "/static/images/icons/account_icon.svg",
          alt: "account-icon",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "account_img_icon" }, [
      _c("img", {
        attrs: { src: "/static/images/icons/user_icon.svg", alt: "user-icon" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "summary_header" }, [
      _c("tr", { staticClass: "service_header rounded-top" }, [
        _c("th", {
          staticClass: "service_header_content",
          attrs: { scope: "col" },
        }),
        _c(
          "th",
          { staticClass: "service_header_content", attrs: { scope: "col" } },
          [_vm._v("This Week")]
        ),
        _c(
          "th",
          { staticClass: "service_header_content", attrs: { scope: "col" } },
          [_vm._v("Previous Week")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "service_header" }, [
      _c("div", { staticClass: "account_img_icon" }, [
        _c("img", {
          attrs: {
            src: "/static/images/icons/account_icon.svg",
            alt: "account-icon",
          },
        }),
      ]),
      _c("div", { staticClass: "account_header_content" }, [
        _vm._v("Premium Services"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", { staticClass: "service_header" }, [
        _c(
          "th",
          { staticClass: "service_header_content", attrs: { scope: "col" } },
          [_vm._v("Service Name")]
        ),
        _c(
          "th",
          { staticClass: "service_header_content", attrs: { scope: "col" } },
          [_vm._v("REP accounts")]
        ),
        _c(
          "th",
          { staticClass: "service_header_content", attrs: { scope: "col" } },
          [_vm._v("Commercial accounts")]
        ),
        _c(
          "th",
          { staticClass: "service_header_content", attrs: { scope: "col" } },
          [_vm._v("Expiring in 30 days")]
        ),
        _c(
          "th",
          { staticClass: "service_header_content", attrs: { scope: "col" } },
          [_vm._v(" Expiring > 30 days and ≤ 45 days ")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 mlb-10" }, [
        _c("span", { staticClass: "sub-content-header" }, [
          _vm._v("Service Manager"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-3 col-xs-3 icon-container" }, [
      _c("div", {}, [
        _c("img", {
          attrs: {
            src: "/static/images/icons/submission_icon.svg",
            alt: "submission-icon",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 mlb-10" }, [
        _c("span", { staticClass: "sub-content-header" }, [
          _vm._v("Operations"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-3 col-xs-3 icon-container" }, [
      _c("div", {}, [
        _c("img", {
          attrs: {
            src: "/static/images/icons/submission_icon.svg",
            alt: "submission-icon",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "product-service" }, [
      _c("span", { attrs: { "data-v-481e9ed3": "" } }, [
        _vm._v("Smart Builder"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-3 col-xs-3 icon-container" }, [
      _c("div", {}, [
        _c("img", {
          attrs: {
            src: "/static/images/icons/submission_icon.svg",
            alt: "submission-icon",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "product-service" }, [
      _c("span", { attrs: { "data-v-481e9ed3": "" } }, [_vm._v("RAMS")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 mlb-10" }, [
        _c("span", { staticClass: "sub-content-header" }, [_vm._v("System")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-3 col-xs-3 icon-container" }, [
      _c("div", {}, [
        _c("img", {
          attrs: {
            src: "/static/images/icons/dashboard_icon.svg",
            alt: "dashbaord-icon",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-3 col-xs-3 icon-container" }, [
      _c("div", {}, [
        _c("img", {
          attrs: {
            src: "/static/images/icons/rbac-admin.svg",
            alt: "rbac-admin-icon",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }